import { useCallback, useEffect } from 'react';

// Принимает мемоизированный callback
const useOuterClickListener = (ref, callback) => {
  const onClickListener = useCallback(
    (e) => {
      if (!ref.current?.contains(e.target)) {
        callback();
      }
    },
    [callback, ref]
  );

  useEffect(() => {
    document.addEventListener('click', onClickListener);
    return () => document.removeEventListener('click', onClickListener);
  }, [onClickListener]);
};

export default useOuterClickListener;